import { render, staticRenderFns } from "./Grid22.vue?vue&type=template&id=67addc7f&scoped=true"
import script from "./Grid22.vue?vue&type=script&lang=ts"
export * from "./Grid22.vue?vue&type=script&lang=ts"
import style0 from "./Grid22.vue?vue&type=style&index=0&id=67addc7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67addc7f",
  null
  
)

export default component.exports